<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-14 09:20:32
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="base" :tab="t('common.baseTabs')">
            <baseMessage :disabled="true" view @getDetail="getDetail" :hideOk="true" />
            <commitList
              ref="commitListRef"
              :permissionPage="{
                delCommit: type === 'view' ? 'ofbu_follow_view_del_commit' : 'ofbu_follow_list_del_commit'
              }"
              :data="detail.commentList"
              :id="route.query.id"
            />
            <a-form name="detailsForm" ref="formRef" :model="form" v-if="commentComputed">
              <dc-layout-card :title="t('follow.commentTitle')">
                <a-col :span="24">
                  <Editor
                    v-model:value="form.content"
                    :maxlength="3000"
                    v-model:mention="form.userCodes"
                    :placeholder="t('common.pleaseInput')"
                  />
                </a-col>
                <dc-form-item :label="t('follow.UploadAttachments')" name="fileId" :span="24">
                  <UploadFile v-model:value="form.fileId" valueType="array" />
                </dc-form-item>
              </dc-layout-card>
            </a-form>
          </a-tab-pane>
          <a-tab-pane key="operationLog" :tab="t('common.operationLogTabs')">
            <TabsOperationLog tableId="DcCosOfbuFollowUpOperationLog" appId="cos_ofbu" :resourceId="route.query.id" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <cos-footer-button :loading="loading" hideOk>
        <a-button
          v-show="commentComputed && activeKey === 'base'"
          type="primary"
          @click="handleCommit"
          :loading="loading"
          v-permission="'ofbu_follow_comment_btn'"
          >{{ t('btn.issue') }}</a-button
        >
        <template v-if="type === 'view'">
          <a-button
            v-show="!commentComputed && activeKey === 'base'"
            @click="showCommentFrom"
            :loading="loading"
            v-permission="'ofbu_follow_comment_btn'"
            >{{ t('btn.comment') }}</a-button
          >
          <SellerButton
            type="primary"
            :workCode="detail.dutyBy"
            controlType="none"
            @click="handleEdit"
            :loading="loading"
            v-permission="'ofbu_follow_edit_btn'"
            >{{ t('btn.edit') }}</SellerButton
          >
        </template>
      </cos-footer-button>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'
import baseMessage from '../components/baseMessage.vue'
import commitList from '../components/commitList.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import Editor from '@/components/Editor'
import UploadFile from '@/components/UploadFile'
import { DcMessage } from '@dc-platform/dc-components'
import { followRecordsAddComment } from '@/api/overseasSales/followUpManage'
import type { commentItem, FbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
import { layoutTags } from '@dc-platform/dc-interaction'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const form = ref<commentItem>({
  fileId: []
})
const props = defineProps({
  type: {
    default: String
  }
})
const activeKey = ref('base')
const loading = ref(false)
const detail = ref({})
const commitListRef = ref()
const showComment = ref(false)
const commentComputed = computed(() => {
  if (props.type === 'comment') {
    return true
  }
  return showComment.value
})
//
const showCommentFrom = () => {
  showComment.value = true
  // setTimeout(() => {
  //   const h = document.body.clientHeight
  //   window.scrollTo({
  //     top: h
  //     // behavior: 'smooth'
  //   })
  // }, 50)
}
const handleCommit = () => {
  if (!form.value.content) {
    // const h = document.getElementById('app')?.scrollHeight
    // document.getElementById('app')?.scrollTo({
    //   top: h,
    //   behavior: 'smooth'
    // })
    DcMessage.warning(t('tips.inputComment'))
    return
  }
  loading.value = true
  // 评论必填
  followRecordsAddComment({
    followId: route.query.id,
    ...form.value
  })
    .then((res) => {
      DcMessage.success(t('tips.commentSuccess'))
      layoutTags.close()
    })
    .finally(() => {
      loading.value = false
    })
}
const getDetail = (data: FbuFollowUpRecordEdit) => {
  detail.value = data
}
const handleEdit = () => {
  router.push({
    path: '/ofbu/followUpRecord/edit',
    query: {
      id: route.query.id
    }
  })
}
</script>
<script lang="ts">
export default {
  name: 'DcCosOFbuFollowUpRecordCommit'
}
</script>
